import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../../components/Banner';
import Layout from '../../components/Layout';
import Detail from '../../components/Outlet/Detail';
import ListMenu from '../../components/Outlet/ListMenu';
import Service from '../../components/Outlet/Service';
import { HeaderSlot } from '../../../utils/constants';
import { handleGetStoreDetail } from '../../../store/reducers/outlet';
import { uniqueID } from '../../../utils/constants';
import { getBannerList } from '../../../store/reducers/banner';
import Header from '../../components/Header';
import Loader from '../../../components/Loader';
import { initGoogleAnalytics, isEmptyData, sendAnalyticsPageView } from '../../../utils/helper';
import Footer from '../../components/Footer';
import ActiveOrder from '../../components/Orders/ActiveOrder';
import Articles from '../../components/Article';
import useCurrentLocation from '../../hook/useCurrentLocation';

const Home = () => {
  useCurrentLocation();
	const dispatch = useDispatch();

	const { details: outlet, isLoadingOtherLocation } = useSelector((store) => store?.outlet);
	const { data: banners = [], loading } = useSelector((state) => state.banner);
	const user = useSelector((store) => store?.user);
	const company = useSelector((store) => store?.company);

	const handleGetOutlet = async () => {
		if (isEmptyData(company?.brandId)) return;
		dispatch(
			handleGetStoreDetail({
        companyID: company?.companyID,
				brandID: company?.brandId,
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	};

	useEffect(() => {
		handleGetOutlet();
	}, [company?.brandId, user?.latitude, user?.longitude]);

	useEffect(() => {
		if (isEmptyData(company?.companyID)) return;
		dispatch(getBannerList({ unquieid: uniqueID, companyID: company?.companyID }));
	}, [company?.companyID]);

  useEffect(() => {
    if (isEmptyData(user?.googleAnalytic)) return;
    initGoogleAnalytics(user?.googleAnalytic);
  }, [user?.googleAnalytic])
  

  useEffect(() => {
    if (isEmptyData(outlet?.storeName) || typeof window.gtag !== 'function') return;
    sendAnalyticsPageView(outlet?.storeName);
  }, [outlet?.storeName, window.gtag]);

	const outletProps = useMemo(() => {
		return {
			name: outlet?.storeName,
			image: outlet?.storeImage,
			isOpen: outlet?.storeOpen,
		};
	}, [outlet?.storeName, outlet?.storeImage, outlet?.storeOpen]);

	const headerProps = {
		slots: {
			right: {
				content: [HeaderSlot.CUSTOMERCARE, HeaderSlot.TRANSACTION],
			},
		},
	};

	const bannerProps = useMemo(() => {
		return {
			data: isEmptyData(banners)
				? [
						{
							banner_image: null,
						},
				  ]
				: banners,
			isLoading: isEmptyData(banners) ? false : loading,
			className: 'w-screen !-m-4 relative max-w-3xl',
		};
	}, [banners, loading]);

	const layoutProps = {
		className: {
			second: '!pb-0',
		},
	};

	const pageLoading = isLoadingOtherLocation;

	return (
		<Layout {...layoutProps}>
			<div className='flex flex-col min-h-[calc(100vh-2rem)]'>
				<div className='flex-1'>
					{pageLoading && <Loader overlay className={'-mx-4'} />}
					<Header {...headerProps} />
					<Banner {...bannerProps} />
					<Detail {...outletProps} />
					<Service {...outletProps} />
					<ListMenu />
					<Articles />
					<ActiveOrder />
				</div>
        <Footer />
			</div>
		</Layout>
	);
};

export default Home;
